import React from 'react';
import PropTypes from 'prop-types';
import './style/ProjectCard.css';

const ProjectCard = ({ project }) => {
  const {
    title,
    description,
    link,
    thumbnail,
  } = project; 

  console.log(project);

 

  return (
    <div className="custom-project-card">
     <img
        src={thumbnail || 'https://via.placeholder.com/300x200?text=No+Image'}
        alt={title}
        className="card-img"
      />


      <div className="card-content">
        <h5 className="card-title">{title}</h5>

        {Array.isArray(description) ? (
          description.map((item, index) => (
            <p key={index} className="card-description">{item}</p>
          ))
        ) : (
          <p className="card-description">{description}</p>
        )}

        {/* <a
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          className="demo-button"
        >
          Live Demo
        </a> */}
      </div>
    </div>
  );
};

ProjectCard.propTypes = {
  project: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.arrayOf(PropTypes.string)
    ]).isRequired,
    link: PropTypes.string.isRequired,
    image: PropTypes.string
  }).isRequired,
};

export default ProjectCard;
